import React, {useEffect, useState } from "react";
import { Text, View } from "react-native";

import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";
import NumberInput from "../../components/NumberInput";
import GradientButton from "../../components/GradientButton";
import AsyncStorage from "@react-native-async-storage/async-storage";

const DepositMethod = () => {
  const navigation = useNavigation();

  const [amount, setAmount] = useState(150);

  useEffect(() => {
    if(amount < 150) {
      setAmount(150);
    }
  }, [amount]);

  async function onSubmit() {
    await AsyncStorage.setItem('depositAmount', `${amount}`);
    navigation.navigate('DepositPaymentMethod');
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={"Depositar BRL"} />

      <View style={styles.container}>
        <View style={styles.inputContainer}>
          <NumberInput
            value={amount}
            onChange={setAmount}
            minValue={150}
          />
        </View>
        <View style={{alignItems: 'center'}}>
          <Text style={{color: '#656565'}}><Text style={{fontWeight: 'bold'}}>TAXAS E INFORMAÇÕES:</Text>{"\n"}As taxas de depósito são:{"\n"}- R$ 0,99 para PIX.{"\n"}- R$ 3,00 para Boleto.{"\n"}As taxas serão descontadas do valor a ser descontado em GPX.{"\n"}(O valor mínimo para depósito é de R$ 150,00).</Text>
        </View>
        <GradientButton onPress={onSubmit}>Escolher forma de pagamento</GradientButton>
      </View>
    </View>
  );
};

export default DepositMethod;
